/**
 * Generated by orval v8.0.0-rc.0 🍺
 * Do not edit manually.
 */
import type {
  AdminV1MenuCreateReq,
  AdminV1MenuCreateRes,
  AdminV1MenuDeleteRes,
  AdminV1MenuInfo,
  AdminV1MenuListRes,
  AdminV1MenuTreeRes,
  AdminV1MenuUpdateRes,
  GetMenuTreeParams,
  ListMenuParams,
  UpdateMenuBody
} from './models';

import { customInstance } from '../mutator';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAdminMenu = () => {
/**
 * @summary 获取菜单列表
 */
const listMenu = (
    params?: ListMenuParams,
 options?: SecondParameter<typeof customInstance<AdminV1MenuListRes>>,) => {
      return customInstance<AdminV1MenuListRes>(
      {url: `/v1/menu`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary 创建菜单
 */
const createMenu = (
    adminV1MenuCreateReq: AdminV1MenuCreateReq,
 options?: SecondParameter<typeof customInstance<AdminV1MenuCreateRes>>,) => {
      return customInstance<AdminV1MenuCreateRes>(
      {url: `/v1/menu`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminV1MenuCreateReq
    },
      options);
    }
  /**
 * @summary 获取菜单树
 */
const getMenuTree = (
    params?: GetMenuTreeParams,
 options?: SecondParameter<typeof customInstance<AdminV1MenuTreeRes>>,) => {
      return customInstance<AdminV1MenuTreeRes>(
      {url: `/v1/menu/tree`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary 删除菜单
 */
const deleteMenu = (
    id: number,
 options?: SecondParameter<typeof customInstance<AdminV1MenuDeleteRes>>,) => {
      return customInstance<AdminV1MenuDeleteRes>(
      {url: `/v1/menu/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary 获取菜单详情
 */
const getMenu = (
    id: number,
 options?: SecondParameter<typeof customInstance<AdminV1MenuInfo>>,) => {
      return customInstance<AdminV1MenuInfo>(
      {url: `/v1/menu/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary 更新菜单
 */
const updateMenu = (
    id: number,
    updateMenuBody: UpdateMenuBody,
 options?: SecondParameter<typeof customInstance<AdminV1MenuUpdateRes>>,) => {
      return customInstance<AdminV1MenuUpdateRes>(
      {url: `/v1/menu/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMenuBody
    },
      options);
    }
  return {listMenu,createMenu,getMenuTree,deleteMenu,getMenu,updateMenu}};
export type ListMenuResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminMenu>['listMenu']>>>
export type CreateMenuResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminMenu>['createMenu']>>>
export type GetMenuTreeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminMenu>['getMenuTree']>>>
export type DeleteMenuResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminMenu>['deleteMenu']>>>
export type GetMenuResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminMenu>['getMenu']>>>
export type UpdateMenuResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminMenu>['updateMenu']>>>
